export const stockEndPoints = {
  getList: (queryString: string) => `/stock/list${queryString}`,
  getListByType: (queryString: string) => `/stock/listByType/${queryString}`,
  getListByIds: (queryString: string) => `/stock/listByIds/${queryString}`,
  create: () => '/stock/create',
  update: (id: string) => `/stock/update/${id}`,
  reservationCreate: () => '/stock/reservation/create',
  reservationAbort: () => `/stock/reservation/abort`,
};
